var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.invoices,"search-options":{
                enabled: true,
            }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'id')?_c('span',[_c('router-link',{class:[
                            'block outline-none sidebar-item',
                            { active: _vm.$route.path === null },
                        ],attrs:{"to":`/invoices/1`}},[_vm._v(_vm._s(props.formattedRow[props.column.field]))])],1):_vm._e()]}}])})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"mb-3"},[_c('strong',[_vm._v("Invoice Report")])])
}]

export { render, staticRenderFns }